type PageContainerProps = {
  children: React.ReactNode
  containerClass?: string
}

export const PageContainer = ({ children, containerClass = '' }: PageContainerProps) => (
  <main className={`container container--body ${containerClass}`}>{children}</main>
)
